/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".appver[_ngcontent-%COMP%]{padding-top:100px;font-size:24px;text-align:center}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/auth/version/version.component.scss.shim.ngstyle.js.pre-build-optimizer.js